// src/pages/PrivacyPolicy.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Headerr from "./Headerr";
import "../../../assets/css/PrivacyPolicy.css";
import NoCopyWrapper from "../../../utils/NoCopyWrapper";
import Footer from "../Footer";
import NoZoomWrapper from "../../../utils/NoZoomWrapper";
const PrivacyPolicy = () => {
  const [active, setActive] = useState("privacy"); // default tab

  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Headerr />

          {/* Header Section */}
          <div className="privacy-header">
            <h1>Privacy Policy</h1>
            <p>
              <Link to="/" className="breadcrumb-home">
                Home
              </Link>{" "}
              /<span className="breadcrumb-current"> Privacy Policy</span>
            </p>
          </div>

          <div className="container">
            <div className="page-container">
              {/* Sidebar */}
              <div className="sidebar">
                <h4>Articles in this section</h4>
                <ul>
                  <li
                    className={active === "privacy" ? "active-box" : ""}
                    onClick={() => setActive("privacy")}
                  >
                    Privacy Policy Last <br />
                    <small> Updated – [1/03/2025]</small>
                  </li>
                  <li
                    className={active === "delete" ? "active-box" : ""}
                    onClick={() => setActive("delete")}
                  >
                    Delete Your Account <br />
                    <small>Last Updated [1/03/2025]</small>
                  </li>
                  <li
                    className={active === "disclaimer" ? "active-box" : ""}
                    onClick={() => setActive("disclaimer")}
                  >
                    Disclaimer – Rentel: Rent Element-Last <br />
                    <small>Updated [1/03/2025]</small>
                  </li>
                </ul>
              </div>

              {/* Right Side Content */}
              <div className="content">
                {active === "privacy" && (
                  <>
                    <h2>Privacy Policy - Last Updated [1/03/2025]</h2>
                    <h3>1. Introduction</h3>
                    <p>
                      Welcome to Rentel – Rent Element. Your privacy is
                      important to us, and we are committed to protecting your
                      personal data. This Privacy Policy explains how we
                      collect, use, disclose, and safeguard your information
                      when you use our app and services.
                    </p>
                    <h3>2. Information We Collect</h3>
                    <ul>
                      <li>
                        <b>Personal Information:</b> Name, email address and
                        phone number details.
                      </li>
                      <li>
                        <b>Device Information:</b> IP address, device ID,
                        operating system, and browser type.
                      </li>
                      <li>
                        <b>Usage Data:</b> App interactions, rental/buy history,
                        and preferences.
                      </li>
                      <li>
                        <b>Location Data:</b> With your permission, we collect
                        location data for better service recommendations.
                      </li>
                    </ul>
                    <h3>3. How We Use Your Information</h3>
                    <ul>
                      <li>Providing and managing the app’s services.</li>
                      <li>Processing transactions securely.</li>
                      <li>Improving app functionality and user experience.</li>
                      <li>
                        Sending notifications and marketing (if opted-in).
                      </li>
                      <li>Ensuring security and fraud prevention.</li>
                      <li>Complying with legal obligations.</li>
                    </ul>
                    <h3>4. Sharing Your Information</h3>
                    <ul>
                      <li>
                        <b>Service Providers:</b> Payment processors, cloud
                        storage, and analytics services.
                      </li>
                      <li>
                        <b>Legal Authorities:</b> When required by law or to
                        protect user safety.
                      </li>
                      <li>
                        <b>Business Transfers:</b> In case of a merger, sale, or
                        acquisition.
                      </li>
                    </ul>
                    <h3>5. Data Storage and Security</h3>
                    <p>
                      We implement industry-standard security measures to
                      protect your data. However, no method is 100% secure, so
                      we encourage safe browsing and secure password practices.
                    </p>
                    <h3>6. Your Rights and Choices</h3>
                    <ul>
                      <li>Access, update, or delete your personal data.</li>
                      <li>Opt out of marketing communications.</li>
                      <li>
                        Withdraw consent for data collection (may limit app
                        functionality).
                      </li>
                    </ul>
                    <h3>7. Third-Party Services</h3>
                    <p>
                      Our app may include links to third-party services or
                      advertisements. We are not responsible for their privacy
                      practices, so please review their policies.
                    </p>
                    <h3>8. Children’s Privacy</h3>
                    <p>
                      Our services are not intended for users under 18. We do
                      not knowingly collect data from minors.
                    </p>
                    <h3>9. Changes to This Policy</h3>
                    <p>
                      We may update this policy from time to time. Any
                      significant changes will be notified via the app or email.
                    </p>
                    <h3>10. Contact Us</h3>
                    <p className="info-text">
                      For questions regarding this Privacy Policy, contact us
                      at:
                    </p>
                    <div className="contact-row">
                      <span className="label">
                        📧 <strong>Email:</strong>
                      </span>
                      <span className="email">contact@rentel.in</span>
                    </div>
                    _
                    <p className="disclaimer-note">
                      This policy ensures compliance with Google Play Store,
                      Apple App Store, and Indian data protection laws (e.g., IT
                      Act 2000, PDP Bill 2019).
                    </p>
                  </>
                )}

                {active === "delete" && (
                  <div className="delete-account">
                    <h2>How to Request Account Deletion</h2>
                    <h5>
                      If you wish to delete your Rentel account permanently,
                      follow these steps:
                    </h5>
                    <p>
                      At Rentel – Rent Element, we respect user privacy and
                      provide a simple process to delete your account and
                      associated data upon request.
                    </p>

                    <h3>Option 1: Online Request (Via Website)</h3>
                    <ol>
                      <li>
                        Visit our Account Deletion Page: <b>rentel.in</b>
                      </li>
                      <li>
                        Fill out the Account Deletion Request Form with your
                        registered email / phone number.
                      </li>
                      <li>
                        Submit the request. Our team will process your request
                        within 7 business days.
                      </li>
                    </ol>

                    <h3>Option 2: Email Request</h3>
                    <ol>
                      <li>
                        Send an email to{" "}
                        <a href="mailto:support@rentel.in">support@rentel.in</a>{" "}
                        with the subject <b>“Account Deletion Request.”</b>
                      </li>
                      <li>
                        Include your registered email, phone number, and reason
                        (optional).
                      </li>
                      <li>
                        Our support team will verify your identity and process
                        the request within 7 days.
                      </li>
                    </ol>

                    <h3>Option 3: Important Notes</h3>
                    <ul>
                      <li>Once deleted, your account cannot be recovered.</li>
                      <li>
                        Any pending transactions or unresolved disputes must be
                        settled before deletion.
                      </li>
                      <li>
                        Some residual data (like transaction records) may be
                        retained for compliance with legal obligations.
                      </li>
                    </ul>
                    <p className="note">
                      We may update this policy from time to time. Any
                      significant changes will be notified via the app or email.
                    </p>

                    <h3>For further assistance, contact us at:-</h3>
                    <ul className="contact">
                      <li>
                        📧 Email:{" "}
                        <a href="mailto:support@rentel.in">support@rentel.in</a>
                      </li>
                      <li>
                        📍 Address: MBC Shoping, Mota Varachha, Surat
                        Gujrat-394101
                      </li>
                    </ul>
                  </div>
                )}

                {active === "disclaimer" && (
                  <div className="disclaimer-container">
                    <h2 className="disclaimer-title">
                      Privacy Policy – Last Updated [01/03/2025]
                    </h2>
                    <h3>1. General Disclaimer</h3>
                    <p>
                      Rentel – Rent Element is an online platform designed to
                      facilitate the renting and purchasing of various items and
                      services. By using this App, you acknowledge that Rentel
                      is only an intermediary and does not own, sell, or
                      guarantee any items listed by users. We do not assume any
                      responsibility for the accuracy, safety, legality, or
                      quality of the items rented or sold through this platform.
                    </p>
                    <h3>2. User Responsibility & Agreement</h3>
                    <ul>
                      <li>
                        You are fully responsible for any transactions made
                        through the App.
                      </li>
                      <li>
                        Rentel does not verify user listings or product
                        conditions.
                      </li>
                      <li>
                        You must conduct your own due diligence before renting
                        or purchasing items.
                      </li>
                      <li>
                        Rentel is not responsible for any loss, damage, fraud,
                        or legal issues arising from interactions between users.
                      </li>
                      <li>
                        You agree to use the platform legally and abide by all
                        applicable laws in your region.
                      </li>
                    </ul>
                    <h3>3. Payment Responsibility</h3>
                    <ul>
                      <li>
                        Payments are handled by third-party gateways. Any
                        disputes must be resolved with the provider.
                      </li>
                      <li>
                        Rentel does not provide refunds, compensation, or
                        financial reimbursement for incomplete or disputed
                        transactions.
                      </li>
                    </ul>
                    <h3>4. Liability Limitation</h3>
                    <ul>
                      <li>
                        Rentel and its affiliates shall not be liable for
                        direct, indirect, or consequential damages.
                      </li>
                      <li>
                        Losses due to fraudulent transactions,
                        misrepresentation, or violation of agreements are not
                        covered.
                      </li>
                      <li>
                        Any hacking or unauthorized access affecting user
                        accounts is not our liability.
                      </li>
                    </ul>
                    <h3>5. No Warranty</h3>
                    <p>
                      The App is provided “AS IS” and “AS AVAILABLE” without any
                      guarantees or warranties. We do not warrant error-free,
                      secure, or continuous operation.
                    </p>
                    <h3>6. Rentel's Rights</h3>
                    <ul>
                      <li>
                        Rentel reserves the right to remove users, listings, or
                        content that violates our policies.
                      </li>
                      <li>
                        Services may be suspended or modified anytime without
                        prior notice.
                      </li>
                    </ul>
                    <h3>7. Dispute Resolution</h3>
                    <p>
                      Rentel is not responsible for resolving disputes. Issues
                      must be resolved directly between involved parties.
                    </p>
                    <h3>8. Changes To This Disclaimer</h3>
                    <p>
                      We reserve the right to modify or update this Disclaimer
                      at any time. Continued use of the App means you accept the
                      updated terms.
                    </p>
                    <h3>9. Contact Information</h3>
                    <p className="info-text">
                      For any legal concerns, inquiries, or disputes, contact us
                      at:
                    </p>
                    <div className="contact-row">
                      <span className="label">
                        📧 <strong>Email:</strong>
                      </span>
                      <span className="email">contact@rentel.in</span>
                    </div>
                    <p className="disclaimer-note">
                      This{" "}
                      <strong>detailed and legally clear disclaimer</strong>{" "}
                      ensures Rentel is protected from liabilities while
                      informing users of their responsibilities.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default PrivacyPolicy;
